import { takeLatest, put } from 'redux-saga/effects';
import { DataLayer } from '@grandvisionhq/analytics';
import { clearEvents } from '../utils.js';
import { DOWNLOAD_PRESCRIPTION } from './actions.js';

function* onDownloadPrescription() {
    const evt = {
        event: 'myAccount',
        events: {
            category: 'my prescriptions',
            action: {
                block: 'prescriptions',
                interaction: 'download'
            }
        }
    };
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(evt));
}
/**
 * Main export
 */ var PrescriptionsSagas = [
    takeLatest(DOWNLOAD_PRESCRIPTION, onDownloadPrescription)
];

export { PrescriptionsSagas as default, onDownloadPrescription };
//# sourceMappingURL=sagas.js.map
